import { render } from "./Persona_MedioPers.vue?vue&type=template&id=7c4041d5&scoped=true"
import script from "./Persona_MedioPers.vue?vue&type=script&lang=js"
export * from "./Persona_MedioPers.vue?vue&type=script&lang=js"

import "./Persona_MedioPers.vue?vue&type=style&index=0&id=7c4041d5&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4041d5"]])

export default __exports__